import { render, staticRenderFns } from "./TaskbarStartMenu.vue?vue&type=template&id=5f937444&scoped=true&"
import script from "./TaskbarStartMenu.vue?vue&type=script&lang=js&"
export * from "./TaskbarStartMenu.vue?vue&type=script&lang=js&"
import style0 from "./TaskbarStartMenu.vue?vue&type=style&index=0&id=5f937444&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f937444",
  null
  
)

export default component.exports